import Button from '@material-ui/core/Button';
import * as globals from '@wandb/common/css/globals.styles';
import {hexToRGB} from '@wandb/common/css/globals.styles';
import {useSyncedState} from '@wandb/common/util/hooks';
import React from 'react';
import {useCallback} from 'react';
import styled from 'styled-components';

import {
  setViewerUsingAdminPrivileges,
  viewerUsingAdminPrivileges,
} from '../../../util/admin';
import {IconWarning} from '../../Icon';

const AdminModeWarning = () => {
  const {
    state: viewerUsingAdminPrivilegesLocal,
    setState: setViewerUsingAdminPrivilegesLocal,
  } = useSyncedState({
    stateToSyncWith: viewerUsingAdminPrivileges(),
    setStateToSyncWith: setViewerUsingAdminPrivileges,
  });
  const toggleViewerUsingAdminPrivileges = useCallback(() => {
    setViewerUsingAdminPrivilegesLocal(!viewerUsingAdminPrivilegesLocal);
    setTimeout(() => window.location.reload(), 500);
  }, [viewerUsingAdminPrivilegesLocal, setViewerUsingAdminPrivilegesLocal]);

  return (
    <TextBox>
      <IconWarning style={iconStyle} />
      <StyledText>You are using W&B in Admin mode.</StyledText>
      <Button style={buttonStyle} onClick={toggleViewerUsingAdminPrivileges}>
        Turn off
      </Button>
    </TextBox>
  );
};

export default AdminModeWarning;

const TextBox = styled.div`
  background-color: ${hexToRGB(globals.GRAY_900, 0.12)};
  border-radius: 5px;
  margin-top: 5px;
  padding-top: 5px;
  margin-bottom: 5px;
  padding-bottom: 5px;
  margin-right: 32px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledText = styled.div`
  text-align: left;
  width: 235px;
  justify-content: center;
`;

const iconStyle: React.CSSProperties = {
  width: '20px',
  height: '20px',
  position: 'relative',
  marginLeft: '8px',
  marginRight: '8px',
};

const buttonStyle: React.CSSProperties = {
  backgroundColor: 'transparent',
  fontSize: 'inherit',
  fontWeight: 600,
  color: 'white',
  marginLeft: '2px',
  marginRight: '12px',
  paddingRight: '0px',
  paddingLeft: '0px',
  paddingTop: '0px',
  paddingBottom: '0px',
};
